import { w } from './globals';

export const getTime: () => number = Date.now ? () => Date.now() : () => +new Date();

// NOTE: Because we are using the result of now to measure elapsed time, we want the higest resolution
// time available to use that is not subject to the user changing their clock. The function that meets
// those requirements is `performance.now`. However in older browsers we fallback to `Date.now`.
// Do not use perfNow to get the current system time as in will not return it to you in most browsers.
// `performance.now` is generally the number of milliseconds since the browser tab was opened.
// See https://mythbusters.js.org/#/date/timestamp

/**
 * Get a number to use in performance timings
 * @returns A number measured in milliseconds, accurate to five thousandths of a millisecond (5 microseconds).
 * The returned value represents the time elapsed since the time origin (approximately performance.timing.navigationStart).
 */
export const perfNow = () => w.performance.now();

/**
 * Get an array of PerformanceEntries. Presumably those from the Performance API. If
 * said API is not available, then an empty array is returned.
 */
export const getPerfEntries = () => {
    if (w.performance && w.performance.getEntries) {
        return window.performance.getEntries();
    }

    return [];
};
